export class MsaAgreementMessages {
  public static readonly PendingCustomerTitle = "Review and accept your Master Service Agreement";
  public static readonly PendingCustomerDescription = "In order to access your funds, review and accept your Master Service Agreement.";
  public static readonly PendingOtherOwnersTitle = "All owners must review and accept the Master Service Agreement";
  public static readonly PendingOtherOwnersDescription = "In order to access your funds, all owners included in your application must review and accept the Master Service Agreement.";
  public static readonly NoneAgreementTitle = "Master Service Agreement not ready";
  public static readonly NoneAgreementDescription = "Your Master Service Agreement is not ready, contact us if you have any questions.";
}
